import { Component, effect, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-backdrop',
  styleUrl: './backdrop.component.scss',
  template: ` <ng-content /> `,
})
export class BackdropComponent {
  visible = input.required<boolean>();

  @HostBinding('class.visible') show = false;

  constructor() {
    effect(() => (this.show = this.visible()));
  }
}
